<div [class]="classObject()">
  <mat-icon fontIcon="chevron_left" class="zwi-button-icon" (click)="back()"></mat-icon>
  <zwi-headline>
    <ng-content></ng-content>
  </zwi-headline>
</div>
